import * as Cookie from "js-cookie";
import { ArbBundle } from "../hooks/use-arb";

const SPANISH = "es";
const ENGLISH = "en";

function getLanguage() {
  const locale = getLocale();
  const language = locale.substr(0, 2);
  return language;
}

export function getLocale(): string {
  const userDefinedLocale = Cookie.get("hvh-locale");

  const DEFAULT_LOCALE = "en-US";
  const locale =
    userDefinedLocale && userDefinedLocale.length >= 2
      ? userDefinedLocale
      : DEFAULT_LOCALE;
  return locale;
}

const localeToLanguageMap: Map<string, string> = new Map([
  ["en-US", "Checklist-General-English"],
  ["es-US", "Checklist-General-Spanish"],
]);

export function isSpanishLocale(): boolean {
  return getLanguage() == SPANISH;
}

export function isEnglishLocale(): boolean {
  return getLanguage() == ENGLISH;
}

export function getRegionFromCookie(): string {
  const locale = getLocale();
  const region = locale.substr(3, 2);
  return region;
}

export function getSupportedLanguage(
  localeList: Array<string> | undefined,
  bundle: ArbBundle
): string {
  if (!localeList) {
    return "";
  }

  let languages = "";
  for (let i = 0; i < localeList.length; i++) {
    const languageKey = localeToLanguageMap.get(localeList[i].trim());
    if (languageKey) {
      languages += bundle.getMessage(languageKey) + ", ";
    }
  }
  return languages.length === 0
    ? languages
    : languages.substr(0, languages.length - 2);
}
